import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import ErrorBoundary from '../components/ErrorBoundary';
import { DemoBanner } from '../components/Ui';
import { HospitalProfileProvider } from '../auth/HospitalProfileContext';
import { isDemoOnlyPath } from '../config/demoModules';

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const showDemo = isDemoOnlyPath(location.pathname);

  return (
    <HospitalProfileProvider>
      <div className="app-shell">
        <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
        <main
          className="app-main"
          style={{ marginLeft: collapsed ? 'var(--sidebar-collapsed)' : 'var(--sidebar-width)' }}
        >
          {showDemo && <DemoBanner />}
          <ErrorBoundary fallback="/manager/dashboard" title="Page error">
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </HospitalProfileProvider>
  );
}
